import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

declare var AwsWafIntegration: any;


export interface TokenServiceResponse {
  tokenName?: string;
  tokenDetails?: {
    apiKey?: string,
    secret?: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private googleMapTokenEndpoint = '';
  //
  // Rest API Endpoint
  //
  private readonly GET_API: string = `token-service/public?tokenName=:keyName`;

  public isMapLoaded$ = new BehaviorSubject<boolean>(false);
  public isMapLoadedError$ = new BehaviorSubject<boolean>(false);
  public apiKey = '';
  public secret = '';

  /**
   * Function: constructor()
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentConfiguration,
  ) {
    this.googleMapTokenEndpoint = `${this.environment.RTI_ENDPOINT}/${this.GET_API}`;
  }

  public getGoogleMapsToken(): Observable<TokenServiceResponse> {
    return new Observable<TokenServiceResponse>((observer) => {
      AwsWafIntegration.getToken().then((token: string) => {
        const url = this.googleMapTokenEndpoint.replace(':keyName', 'googlemap');

        let headers = new HttpHeaders();
        headers.set('Content-Type', 'application/json');
        headers = headers.set('X-Aws-Waf-Token', token);
        headers = headers.set(this.environment.RTI_X_API_KEY, this.environment.RTI_X_API_VALUE);

        this.http.get<TokenServiceResponse>(url, { headers })
          .subscribe(
            (response: TokenServiceResponse) => {
              this.apiKey = response?.tokenDetails?.apiKey;
              this.secret = response?.tokenDetails?.secret;
              observer.next(response);
              observer.complete();
            },
            (error: any) => {
              observer.error(error);
            }
          );
      }).catch((error: any) => {
        observer.error(error);
      });
    });
  }

}
